import {
  Filters_,
  FormGroup,
  FormInput,
  FormLabel,
  Grey_Link,
  IconSvg,
  Main_Plain,
  PageFull,
  PageTitle,
  TBody,
  TD,
  TH,
  THead,
  TR,
  TRH,
  Table,
  TableDesktop,
  Partial_Loader,
  Red_,
  Confirmation_,
  Input_,
  AlertContext,
  Alert_,
  Builder_,
} from "monica-alexandria";
import { useDebounce } from 'use-debounce';
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { get_subscribers } from "../../../services/api/Mocks";
import { Subscriber_Filters } from "./partials/Subscriber_Filters";
import { useNavigate } from "react-router-dom";
import { Sub_Color_Coding } from "./partials/Sub_Color_Coding";
import Subscriber_Edit from "./partials/Subscriber_Edit";
import { showKPIS } from "./utils/kpis";
import styled from "styled-components";
import { calculateDifferenceSum, calculateFeeSum, calculateSum } from "../dailyprofitSubscriber/utils";
import { FiltersContext } from "../../../context/FiltersContext";
import { actually_delete_user, delete_user_preview } from "../../../services/api/Admin";

const DashboardLeadsLoadBtn = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const GoogleSearch = styled.div``;

const GoogleForm = styled(FormGroup)``;

const GoogleInput = styled(FormInput)`
  padding-left: 4.5rem;
`;

const ConfirmationDataWrapper = styled.div`
  max-height: 30rem;
  overflow-y: auto;
  margin-bottom: 1rem;
  padding-right: 1rem;

  p{
    font-weight: 400;
  }
`;

const SectionBlock = styled.div`
  margin-bottom: 1.5rem;
  background:${p => p.theme.mid};
  padding: var(--normalPads);
  border-radius: var(--smallRadius);
`;


const DataItem = styled.p`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-around;
  grid-template-columns: auto 1fr;
  align-items: baseline;
`;


const GoogleLabel = styled(FormLabel)`
  padding-left: 3rem;
`;

const GoogleSearchIcon = styled.div`
  position: absolute;
  top: 1.5rem;
  left: 1rem;

  svg {
    width: 3rem;
    fill: var(--greyDark);
  }
`;

const ConfirmationInfo = styled.div`
    h4{
        padding-bottom: 1rem;
    }
    p,h5{
        /* text-align: left; */
    }
`

const PasswordInput = styled(FormGroup)`   
    display: grid;
  grid-template-columns: 1fr auto;
    svg{
        width: 2.5rem;
    }
`
const SubscribersDifference = styled(TD)`
    color: ${p => p.negative ? 'var(--error)' : 'var(--success)'};
`
const ActionsTD = styled(TD)`
    display: flex;
    align-items: center;
    gap: 1rem;
`

export default function SUBSCRIBERS() {
    
  
    const { t } = useTranslation();

    const navigate = useNavigate();

    const [searchTermm, setSearchTerm] = useState("");
    const [inputType, setInputType] = useState('password')
    const [currPage, setCurrPage] = useState(0);
    const [currPageFilters, setCurrPageFilters] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const [loading, showLoading] = useState(true);

    const [searchTerm] = useDebounce(searchTermm, 2000);
    const [subToDlt, setSubToDlt] = useState(false)
    const [previewDeleteData, setPreviewDeleteData] = useState(false)
    const [deleteData, setDeleteData] = useState({password:'',otp:''})
    
    const [subscribers, setSubscribers] = useState({
        subscribers_with_kpis: [],
        currently_showing: "backend",
        show_loader: false,
    });

    const { alerts, setAlerts } = useContext(AlertContext);

 
    const savedCategory = localStorage.getItem("categoryOption");
    const parsedCategory = savedCategory ? JSON.parse(savedCategory) : [];


    const [filters, setFilters] = useState({ category:parsedCategory?.length>0? parsedCategory :  ['dailyprofit']});

    
   console.log('localStorage.getItem("categoryOption")', localStorage.getItem("categoryOption"));
    // const { filters, setFilters } = useContext(FiltersContext); 
    const [sorting, setSorting] = useState('');


    const [dates, setDates] = useState({
        renderedConversionDates: [],
        renderedLossDates: [],
        conversionDates: {
            sinceDate: "",
            untilDate: "",
        },
        lossDates: {
            sinceDate: "",
            untilDate: "",
        },
    });

    const [slider, toggleSlider] = useState(false);
    const [selectedSub, setSelectedSub] = useState(false);


    const fetchSubscribers = (payload) => {

        console.log('payload');
        
        get_subscribers(payload)
            .then((res) => {
                console.log('gettttttttttttt', res)

                if (!res?.data?.data?.subscribers?.length) {
                    showLoading(false);
                    setSubscribers({
                    ...subscribers, show_loader: true})

                }
                else {
                    showKPIS(subscribers, setSubscribers, showLoading, currPage, currPageFilters, res?.data?.data?.subscribers, filters);
                }
            })
            .catch((err) => {
                setSubscribers({
                    ...subscribers
                });
                showLoading(false);
            });
    };

    const checkDailyprofitStatus = (subscriber) => {
        const dailyprofitSubscriptions = subscriber?.filter(subscription => subscription.category === "dailyprofit");
        let dailyprofitSubscriptionStatus = dailyprofitSubscriptions[0] ?  dailyprofitSubscriptions[0]?.subsriberStatus : '';

        console.log('dailyprofitSubscriptions', dailyprofitSubscriptions);
        
        // if (dailyprofitSubscriptions?.some(subscription => subscription.status === 'active')) {
        //     return 'active';
        // } else if (dailyprofitSubscriptions?.some(subscription => subscription.status === 'past_due')) {
        //     return 'past_due';
        // } else if (dailyprofitSubscriptions?.some(subscription => subscription.status === 'canceled')) {
        //     return 'canceled';
        // }
    
        return dailyprofitSubscriptionStatus; // If no "dailyprofit" subscription matches any of these statuses
    };

    const getMostRecentPeriodStart = (subscriber) => {
        if (!subscriber?.data || subscriber.data.length === 0) return 'N/A';
    
        const mostRecent = subscriber.data.reduce((latest, item) => {
            const currentStartDate = new Date(item.current_period_start);
            const latestDate = new Date(latest.current_period_start);
    
            return currentStartDate > latestDate ? item : latest;
        }, subscriber.data[0]); // Start with the first item as the initial value
    
        return new Date(mostRecent.current_period_start).toLocaleDateString('el-GR'); // Format the date
    };
    
    const fetchWithFilters = () => {
        let payload = {
            filters,
            sorting: sorting.field ? { [sorting.field]: sorting.key } : undefined,
            dateStart: dates.conversionDates.sinceDate || dates.lossDates.sinceDate,
            dateEnd: dates.conversionDates.untilDate || dates.lossDates.untilDate,
            elastic: searchTerm, // Include search term in payload
            pageSize: pageSize,
            currentPage: currPage
        };
        fetchSubscribers(payload);
    };

    const handleConfirmCode =()=>{

        const username = subToDlt?.username;

        actually_delete_user(username, deleteData?.otp)
          .then(res => {
              console.error(res)
              if (res?.data?.code !== 'A2000') setAlerts([...alerts,{ message: {text: t('Access Denied'), status: "Error"}}]);
              else {

                let overview = res?.data?.overview;

                setPreviewDeleteData({
                    Questad: {...previewDeleteData?.Questad, affected: overview?.Questad?.modified || 0 + overview?.Questad?.deleted || 0},
                    Adsnap: {...previewDeleteData?.Adsnap, affected: overview?.Adsnap?.modified || 0 + overview?.Adsnap?.deleted || 0},
                    Miniverse: {...previewDeleteData?.Miniverse, affected: overview?.Miniverse?.modified || 0 + overview?.Miniverse?.deleted || 0},
                    Payments: {...previewDeleteData?.Payments, affected: overview?.Payments?.modified || 0 + overview?.Payments?.deleted || 0},
                    Leads: {...previewDeleteData?.Leads, affected: overview?.Leads?.modified || 0 + overview?.Leads?.deleted || 0},
                    Launchpad: {...previewDeleteData?.Launchpad, affected: overview?.Launchpad?.modified || 0 + overview?.Launchpad?.deleted || 0}
                })
                setAlerts([...alerts,{ message: {text: t('Done'), status: "Success"}}]);
                //window.location.reload();
            }
          })
    }

    useEffect(() => {
        showLoading(true)
        fetchWithFilters();
    }, [filters, dates, sorting, searchTerm, currPage]); // Update on searchTerm change

    useEffect(() => {
        if (filters?.category?.length) {
            showLoading(true);
            setCurrPage(0);
        }
        else {
            setCurrPageFilters(0);
        }
    }, [filters?.category]); // Page number must return back to normal if we exit filter mode

    const handleSearchInput = (e) => {
        setSearchTerm(e.target.value);
    };

    console.error('FILTERS', filters)
    console.error('subs', subscribers)
    console.error('currPage', currPage)
    console.error('dates', dates)
    console.error('preview', previewDeleteData)
console.log('inputType' , inputType);


  return (
    <PageFull>
        <Alert_/>
        {slider ? 
            <Subscriber_Filters
                toggleSlider={toggleSlider} 
                filters={filters}
                setFilters={setFilters}
                dates={dates}
                setDates={setDates}
                sorting={sorting}
                setSorting={setSorting}
            /> 
        : null}
        {selectedSub  ?
            <Subscriber_Edit 
                selectedSub={selectedSub}
                setSelectedSub={setSelectedSub}
            />
        : null}
        {subToDlt ? 
            <Confirmation_
                message ={    
                    <ConfirmationInfo>
                        <h4>{subToDlt?.username}</h4>
                        <ConfirmationDataWrapper>
                            {previewDeleteData && Object.entries(previewDeleteData).map(([sectionName, sectionValue]) => (
                                <SectionBlock key={sectionName}>
                                    <h4>{sectionName}</h4>

                                    {Array.isArray(sectionValue) ? sectionValue.map((item, idx) => (
                                        <DataItem key={idx}>{JSON.stringify(item)}</DataItem>
                                    ))
                                    : typeof sectionValue === 'object' 
                                    ? Object.entries(sectionValue).map(([key, val], i) => (
                                        val > 0 || key === 'quests' || (key === 'metaReports' && val?.length >0) || (key === 'automatedReports' && val?.length >0) || (key === 'presetStructures' && val?.length >0 && key !== 'campaigns')?           
                                            <DataItem key={i}>
                                                <h5>{key}:</h5>{' '}
                                                {Array.isArray(val) ? 
                                                    val.length > 0 ? 
                                                        <p style={{textAlign: 'left'}}>{val.map((v, i) => (<span><b>{i+1}. </b>{v}<br></br></span>))}</p>
                                                        : '[]'
                                                : typeof val === 'object' && key !== 'campaigns'
                                                    ? <p>{JSON.stringify(val)}</p>
                                                : String(val)}
                                            </DataItem>
                                            : null
                                        
                                        ))
                                    : <DataItem>{String(sectionValue)}</DataItem>
                                    }
                                </SectionBlock>
                            ))}
                        </ConfirmationDataWrapper>
                        <p>**Μόλις πατήσετε "Continue", θα εμφανιστεί το πεδίο "affected" κάτω από κάθε πλατφόρμα. Πρόκειται για τα documents
                            της βάσης δεδομένων που επηρεάστηκαν / διαγράφτηκαν. Επαληθέυστε ότι τα νούμερα αυτά είναι σωστά. Αν όχι, επικοινωνήστε <b>άμεσα</b> με τους προγραμματιστές
                        </p>
                        <b></b>
                        {/* <Builder_>
                            <PasswordInput> */}
                            {/* //placeholder='Password' type='password' value={deleteData?.password} onChange={(e)=>setDeleteData({...deleteData, password: e.target.value})} onKeyDown={(e) => {if (e.key === 'Enter') handleConfirmCode()}} */}
                            
                                {/* <Input_ 
                                    placeholder='Password' type={inputType} value={deleteData?.password} onChange={(e)=>setDeleteData({...deleteData, password: e.target.value})} onKeyDown={(e) => {if (e.key === 'Enter') handleConfirmCode()}}
                                />
                                <Main_Plain iconLeft={inputType === 'password' ? "EyeClose" : "EyeOpen"} onClick={()=>inputType === 'password' ? setInputType('text') :setInputType('password') }/>
                            </PasswordInput> */}
                        {/* </Builder_> */}
                        <Input_ 
                            placeholder='OTP' value={deleteData?.otp} onChange={(e)=>setDeleteData({...deleteData, otp: e.target.value})} onKeyDown={(e) => {if (e.key === 'Enter') handleConfirmCode()}}
                        />
                                       
                    </ConfirmationInfo>
                }
                yes={t('Delete')}
                no={t('Cancel')}
                onClose={()=>setSubToDlt(false)}
                onNo={()=>setSubToDlt(false)}
                onYes={()=>  handleConfirmCode()}
            /> 
        :null}
      <PageTitle>
        <Grey_Link noPadding iconLeft="Back" onClick={() => navigate(-1)} />
        <h1>{t("Subscribers")}</h1>
      </PageTitle>
      {!loading ? <Filters_ 
        filters={t("Filters")} 
        onFilters = {() => toggleSlider(true)}
        search={
            <GoogleSearch>
            <GoogleForm>
              <GoogleInput
                placeholder={t('Search subscriber')}
                value={searchTermm}
                onChange={handleSearchInput}
                //onChange={triggerDebounce}
                // defaultValue={currentSearch.defaultValue}
                // disabled={props.disabled}
              />
              <GoogleLabel>{t('Search subscriber')}</GoogleLabel>
              <GoogleSearchIcon>
                <IconSvg Icon="Search" />
              </GoogleSearchIcon>
            </GoogleForm>
          </GoogleSearch> 
        }
      />: <></>}
      <TableDesktop>
      {loading ? <Partial_Loader text={'Loading subs'} /> : null}
        <Table>
            <THead>
                <TRH>
                    <TH>{t("Actions")}</TH>
                    {/* <TH>{filters?.startDate && filters?.endDate ? `Dates: ${filters?.startDate?.toLocaleDateString('el')} - ${filters?.endDate?.toLocaleDateString('el')}` : 'Dates: all-time' }</TH> */}
                    <TH>#</TH>
                    <TH>{t("Last payment")}</TH>
                    <TH>{t("Subscriptions")}</TH>
                    {/* <TH>{t("Subscriptions Total")}</TH> */}
                    <TH>{t("Username")}</TH>
                    <TH>{t("First name")}</TH>
                    <TH>{t("Last name")}</TH>
                    {/* <TH>{t("Questad Total Revenue")}</TH>
                    <TH>{t("Total Fee")}</TH>
                    <TH>{t("Expected AdSpend")}</TH>
                    <TH>{t("Meta Adspend")}</TH> */}
                    <TH>{t("Questad Debt")}</TH>
                </TRH>
            </THead>
            <TBody>
                {subscribers?.subscribers_with_kpis?.map((subscriber, i)=>
                    <TR>
                        <ActionsTD>
                            <Main_Plain iconLeft='EyeOpen' onClick={()=>navigate(`${subscriber?.data[0]?.userId}`)} />
                            <Red_ iconLeft='Delete' onClick={()=>{
                                delete_user_preview(subscriber?.username).then(res => setPreviewDeleteData(res?.data?.overview))
                                setSubToDlt(subscriber)
                            }} />
                        </ActionsTD>
                        {/* <TD><Main_Plain iconLeft='EyeOpen' onClick={()=>setSelectedSub(subscriber)} /></TD> */}
                        <TD>{i + 1}</TD>
                        <TD>{getMostRecentPeriodStart(subscriber)}</TD>
                        {/* <TD>{subscriber?.data[0]?.registered ? new Date(subscriber?.data[0]?.registered).toLocaleDateString('el-GR') : <></>}</TD> */}
                        <TD>
                            <Sub_Color_Coding 
                                lois={subscriber?.data?.some(subscription => subscription.category === "lois")}
                                loisStatus = {subscriber?.data?.find(subscription => subscription.category === "lois")?.status}

                                dailyprofit={subscriber?.data?.some(subscription => subscription.category === "dailyprofit")}
                                dailyprofitStatus = {checkDailyprofitStatus(subscriber?.data)}
                                
                                bond={subscriber?.data?.some(subscription => subscription.category === "bond")} 
                                bondStatus={subscriber?.data?.find(subscription => subscription.category === "bond")?.status}
                            />
                        </TD>
                        {/* <TD>{subscriber?.totalUserRevenue/ 100}</TD> */}
                        <TD>{subscriber?.data[0]?.username}</TD>
                        <TD>{subscriber?.data[0]?.firstname}</TD>
                        <TD>{subscriber?.data[0]?.lastname}</TD>
                        {/* <TD>{subscriber?.totalRevenue?.toFixed(2)}</TD>
                        <TD>{subscriber?.totalFee?.toFixed(2)}</TD>
                        <TD>{subscriber?.totalExpectedAdSpend?.toFixed(2)}</TD>
                        <TD>{subscriber?.metaAdspent?.toFixed(2)}</TD> */}
                        <SubscribersDifference negative={(subscriber?.totalExpectedAdSpend-subscriber?.metaAdspent)<0}>
                            { ((subscriber?.totalExpectedAdSpend ? subscriber?.totalExpectedAdSpend : 0) - (subscriber?.metaAdspent ? subscriber?.metaAdspent : 0))?.toFixed(2)}
                        </SubscribersDifference>
                    </TR>
                )}
                {/* <TR>
                    <TD><b>SUM</b></TD> 
                    <TD></TD> 
                    <TD></TD> 
                    <TD></TD> 
                    <TD><b>{calculateSum(subscribers?.subscribers_with_kpis, 'totalUserRevenue') / 100}</b></TD> 
                    <TD></TD> 
                    <TD></TD> 
                    <TD></TD> 
                    <TD><b>{calculateSum(subscribers?.subscribers_with_kpis, 'totalRevenue')}</b></TD> 
                    <TD><b>{calculateSum(subscribers?.subscribers_with_kpis, 'totalFee')}</b></TD> 
                    <TD><b>{calculateSum(subscribers?.subscribers_with_kpis, 'totalExpectedAdSpend')}</b></TD> 
                    <TD><b>{calculateSum(subscribers?.subscribers_with_kpis, 'metaAdspent')}</b></TD> 
                    <TD><b>{calculateDifferenceSum(subscribers?.subscribers_with_kpis)}</b></TD> 
                </TR> */}
            </TBody>
        </Table>
        
        {!subscribers?.show_loader && subscribers?.subscribers_with_kpis?.length ? 
            <DashboardLeadsLoadBtn>
                <Main_Plain text={t('Load more')} iconLeft='Loading' onClick={()=> {
                    showLoading(true);
                    if (slider) {
                        setCurrPageFilters(currPageFilters+1);
                    }
                    else {
                        setCurrPage(currPage+1);
                    }
                }} />
            </DashboardLeadsLoadBtn> : <></>}
      </TableDesktop>
    </PageFull>
  );
}
